var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Functions.define_LightningLayerGroup = function (in_implements, in_extends, options) {
    var implements = [new Class(OCS.Viewer.Interfaces.LayerGroupInfo), new Class(OCS.Viewer.Interfaces.LayerGroupLayer), new Class(OCS.Viewer.Interfaces.LayerGroupSingleLayer)];
    if (in_implements && in_implements.length) {
        implements.combine(in_implements);
    }
    var class_definition = OCS.Viewer.Functions.define_layer_group(null, OCS.Viewer.Functions.define_base_layer_group(implements, null, options), options);
    return new Class({
        Extends: class_definition,
        class_name: "LightningLayerGroup",
        debug: false,
        style_manager_class: OCS.Viewer.Functions.define_ol_style_manager([new Class(OCS.Viewer.Interfaces.OlLightningStyle)]),
        compute_changes: true,
        reload_interval_id: null,
        datetime_obj: null,
        options: {

        },
        initialize: function (op) {
            this.addEvent('map_datetime_obj_added', this.on_lightning_map_datetime_obj_added.bind(this));
            this.addEvent('layer_added', this.on_layer_added_lightning.bind(this));
            this.addEvent(OCS.Viewer.Config.events.RADAR_UPDATED, this.on_radar_change.bind(this));
            this.parent(op);
        },
        on_lightning_map_datetime_obj_added: function (datetime_obj) {
            this.datetime_obj = datetime_obj;
            var source_ops = this.get_layer_source_options();
            var source = new OCS.Viewer.Classes[source_ops.metadata.source_type + "Source"](source_ops);
            source.create();
            source.set_dateObj(datetime_obj);
            this.addEvent('update_reference_coord', source.set_reference_coord.bind(source));
            this.fireEvent('new_layer_source', source);
        },
        on_layer_added_lightning: function (layer) {
            layer.set_dateObj(this.datetime_obj);
            this.fireEvent('activate_layer', layer, 1);

        },
        on_radar_change: function (radar_options, map) {
            if (radar_options.site) {
                var util = OCS.Viewer.Functions.get_utilities();
                var sel_site = util.get_radar_site_properties(radar_options.site);
                if (sel_site) {
                    this.fireEvent('update_reference_coord', [sel_site.lon, sel_site.lat, map], 1);
                }
            }

        },

        get_layer_short_name: function () {
            if (!this.options.layer_short_name) {
                this.options.layer_short_name = "Lightning";
            }
            return this.options.layer_short_name;
        },
        get_layer_name: function () {
            if (!this.options.layer_name) {
                var dataset_obj = this.get_dataset_obj();
                this.options.layer_name = dataset_obj.getOption('name') + "  Lightning".toLowerCase().capitalize();
            }
            return this.options.layer_name;
        }
    });
};
